export default "__VITE_ASSET__Dv5_mVI8__"